
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.75 24.01a.746.746 0 01-.671-.415l-1.5-3a.753.753 0 01-.079-.335v-9.75c0-1.241 1.009-2.25 2.25-2.25S24 9.269 24 10.51v9.75a.753.753 0 01-.079.335l-1.5 3.001a.747.747 0 01-.671.414zm0-2.427l.75-1.5V10.51a.75.75 0 00-1.5 0v9.573l.75 1.5zM4.5 24.01c-.827 0-1.5-.673-1.5-1.5V6.76a.75.75 0 01.75-.75C4.991 6.01 6 5 6 3.76S4.991 1.51 3.75 1.51 1.5 2.519 1.5 3.76v12a.75.75 0 01-1.5 0v-12A3.754 3.754 0 013.75.01h12A3.747 3.747 0 0118 6.758V22.51c0 .827-.673 1.5-1.5 1.5h-12zm0-1.5h12V7.432a3.652 3.652 0 01-.75.078H4.5v15zm11.25-16.5C16.991 6.01 18 5 18 3.76s-1.009-2.25-2.25-2.25h-9c.483.642.75 1.427.75 2.25s-.267 1.607-.75 2.25h9z"}}),_c('path',{attrs:{"d":"M10.5 13.51a.743.743 0 01-.53-.22l-1.5-1.5c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.743.743 0 01.53-.22c.2 0 .389.078.53.22l.97.97 1.72-1.72a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-2.25 2.25a.743.743 0 01-.53.22zM10.5 18.76a.743.743 0 01-.53-.22l-1.5-1.5a.752.752 0 010-1.061.746.746 0 01.53-.219c.2 0 .389.078.53.22l.97.97 1.72-1.72a.744.744 0 011.06 0 .752.752 0 010 1.061l-2.25 2.25a.746.746 0 01-.53.219z"}})])
          )
        }
      }
    